import * as React from "react"
import { SxProps, Theme, useTheme } from "@mui/material"

import { useNextopiaConfig } from "extensions/one-siam/hooks"

import { useCloudflareWeather } from "./hooks/useCloudflareWeather"
import { WeatherWidget } from "./WeatherWidget"

export interface IAppWeatherWidgetProps {
  sx?: SxProps<Theme>
}

/**
 * Connected wrapper around `WeatherWidget` for the kiosk-v map surfaces
 * (ordinal map, quick-search results, place detail). Sources the venue's
 * Nextopia weather config, fetches the data, and renders nothing when the
 * widget is disabled or the fetch failed.
 *
 * Defaults to `AppMap`'s position; pass `sx` to use a different page's
 * positioning (e.g. place detail's `AppDetailPage` style block).
 */
export const AppWeatherWidget: React.FC<IAppWeatherWidgetProps> = ({ sx }) => {
  const { enableWeatherWidget } = useNextopiaConfig()
  const { data, isFetching, isError } = useCloudflareWeather({
    enabled: enableWeatherWidget,
  })

  const theme = useTheme()
  const { weatherWidget } = theme.components[`AppMap`]?.styleOverrides || {}

  if (!enableWeatherWidget || isError) return null

  return (
    <WeatherWidget sx={sx || weatherWidget} data={data} loading={isFetching} />
  )
}
